/**
 * Contas da tela do Programa de recomendação (proposta do Claude Design, 15/10/2026): a régua
 * "Até onde seus dias chegam", o período sugerido para resgate e quanto rende cada plano.
 * As regras de ganho ficam no backend (lib/ambassador_program.js); aqui só se mostra.
 */

/** Períodos de resgate, em dias (backend REDEEM_DAYS). */
export const REDEEM_STOPS = [1, 7, 31, 92, 365] as const;
export type RedeemStop = (typeof REDEEM_STOPS)[number];

/**
 * Posição (0–100%) de uma quantidade de dias na régua. Os marcos ficam a distâncias iguais
 * (0, 1 dia, 7 dias, 1 mês, 3 meses, 1 ano) e entre dois marcos a posição é proporcional.
 */
export function ladderPosition(days: number): number {
  if (days <= 0) return 0;
  const stops = [0, ...REDEEM_STOPS];
  for (let i = 0; i < stops.length - 1; i++) {
    const from = stops[i]!;
    const to = stops[i + 1]!;
    if (days < to) return Math.round((i + (days - from) / (to - from)) * 2000) / 100;
  }
  return 100;
}

/** Maior período que cabe em `days` (0 se nenhum). */
export function largestStop(days: number): number {
  let best = 0;
  for (const stop of REDEEM_STOPS) if (stop <= days) best = stop;
  return best;
}

/** Próximo período acima de `days` (0 se já passa de 1 ano). */
export function nextStop(days: number): number {
  return REDEEM_STOPS.find((stop) => stop > days) ?? 0;
}

/**
 * Dias que um plano rende: mesma conta do backend (mês = 31 dias, 3 meses = 92, 12 meses ou
 * 1 ano = 365), com o percentual do embaixador, arredondada para baixo como o saldo.
 */
export function planEarning(countedDays: number, percent: number): number {
  return Math.floor((countedDays * percent) / 100);
}

/** Nome do plano a partir do ciclo da compra ("1m", "3m", "1y"...). */
export function planKey(timeCycle: string | null | undefined, daysContracted: number): string {
  const cycle = (timeCycle ?? '').toLowerCase();
  if (cycle === '1m' || daysContracted === 31) return 'monthly';
  if (cycle === '3m' || daysContracted === 92) return 'quarterly';
  if (cycle === '6m' || daysContracted === 183) return 'semiannual';
  if (cycle === '1y' || cycle === '12m' || daysContracted === 365) return 'yearly';
  return 'other';
}
